import { render, staticRenderFns } from "./PopupRiskAssessmentDB.vue?vue&type=template&id=9cf0272e&scoped=true"
import script from "./PopupRiskAssessmentDB.vue?vue&type=script&lang=js"
export * from "./PopupRiskAssessmentDB.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskAssessmentDB.vue?vue&type=style&index=0&id=9cf0272e&prod&scoped=true&lang=scss"
import style1 from "./PopupRiskAssessmentDB.vue?vue&type=style&index=1&id=9cf0272e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf0272e",
  null
  
)

export default component.exports